import * as Api from '@/utils/api/api';
import {makeAutoObservable} from 'mobx';

class NewsInfo {
  title = '';
  content = '';
  publishTime = '';
  updateTime = '';
  source = '';
  author = '';
  watchTimes = '';
  thumbnail = '';
  categoryId = '';
  categoryName = '';
  pre = '';
  next = '';
  recommendList = [];

  constructor() {
    makeAutoObservable(this)
  }

  init() {
    this.title = '';
    this.content = '';
    this.publishTime = '';
    this.updateTime = '';
    this.source = '';
    this.author = '';
    this.watchTimes = '';
    this.thumbnail = '';
    this.categoryId = '';
    this.categoryName = '';
    this.pre = '';
    this.next = '';
  }

   async fetchInfo(id) {
    try {
      const { info } = await Api.newsInfo({ id });
      const {
        title,
        content,
        publishTime,
        updateTime,
        source,
        author,
        watchTimes,
        thumbnail,
        categoryId,
        categoryName,
        pre,
        next
      } = info;

      this.title = title;
      this.content = content;
      this.publishTime = publishTime;
      this.updateTime = updateTime;
      this.source = source;
      this.author = author;
      this.watchTimes = watchTimes;
      this.thumbnail = thumbnail;
      this.categoryId = categoryId;
      this.categoryName = categoryName;
      this.pre = pre;
      this.next = next;
    } catch (error) {}
  }
   async fetchRecommendList() {
    try {
      try {
        const { list } = await Api.newsList({
          pageNum: 2,
          pageSize: 4
        });

        this.recommendList = list;
      } catch (error) {}
    } catch (error) {}
  }
}

const store = new NewsInfo();

export default store;
